/* istanbul ignore file @preserve */ /**
 * DO NOT EDIT!
 * This file was autogenerated by npm script `localizations-codegen`.
 * Changes may cause incorrect behavior and will be lost when the file is regenerated.
 *
 * Run `npx localizations-codegen` to regenerate.
 */ export var defaultTranslations = {
    BackButton: 'Back button',
    ConfirmNewPassword: 'Confirm new password',
    Connect: 'Connect',
    ConnectYourAccount: 'Connect your account',
    ConnectYourAccountDescription: 'Before you sign in, you need to connect your Google  and Oriflame accounts. Enter Oriflame details below. If you click Forgot password, you will need to reconnect again.',
    Continue: 'Continue',
    CreateNewPassword: 'Please create a new password.',
    CurrentPassword: 'Current password',
    ForgotYourPassword: 'Forgot your password?',
    ForgotYourPasswordDescription: 'No problem! Type in your member number, email, or mobile phone that you used when you registered and we will send you details.',
    HidePassword: 'Hide password',
    JoinUs: 'Join our community',
    KeepMeSignIn: 'Keep me signed in',
    KeepMeSignInCookiesTooltip: 'You have not accepted Cookies, so this option is not available to you.',
    MemberNumberOrEmail: 'Member number or e-mail',
    MobilePhone: 'Mobile phone',
    NewPassword: 'New password',
    NewPasswordDescription: 'We have sent you a temporary password, please enter it and then create a new password.',
    NewPasswordTitle: 'New password',
    NewTemporaryPasswordDescription: 'Type in your member number, email, or mobile phone that you used when you registered, temporary password and create a new password.',
    NewToOriflame: 'New to Oriflame?',
    Password: 'Password',
    PasswordlessCancel: 'Cancel registration',
    PasswordlessRegister: 'Register passkey',
    PasswordlessRegisterTitle: 'Passwordless registration',
    PasswordlessSignIn: 'Passkey sign in',
    SelectCountry: 'Select your country',
    SelectCountryPlaceholder: 'Select country',
    ShowPassword: 'Show password',
    SignIn: 'Sign in',
    SignInTitle: 'Sign in',
    SignInWithMemberOrEmail: 'Sign in with Member number or e-mail',
    SignWithMobilePhone: 'Sign in with mobile phone',
    SignWithSocialNetwork: 'or continue with',
    TemporaryPassword: 'Temporary password',
    TemporaryPasswordLink: 'I have a temporary password',
    TenantSelect: 'Tenant select',
    currentPasswordRequired: 'Current password is required',
    enterPassword: 'Enter password',
    enterTemporaryPassword: 'Enter temporary password',
    errUserLockedOut: 'User is locked',
    errUserNotAllowed: 'User login is not allowed',
    errUsernameOrPassword: 'Invalid username or password',
    invalidLoginName: 'Enter email or brand partner number',
    invalidLoginPhone: 'Enter phone number',
    invalidNewPassword: 'Invalid new password',
    invalidPassword: 'Invalid password',
    invalidToken: 'Your temporary password is incorrect',
    keepMeSignInTooltip: 'You will stay logged in for 30 days. Choose this option only on personal devices for safety.',
    memberOrEmailTooltip: 'You can sign in using your consultant number, email or telephone number',
    mobilePhoneTooltip: 'Write your phone in the format XXXXXXXXX',
    mobilePhoneTooltipPhoneWithPrefix: 'Write your phone in the format XXXXXXXXX',
    networkError: 'Network error',
    newPasswordRequired: 'New password is required',
    passwordRequired: 'Password is required.',
    passwordRequirementCharactersCount: '{min}+ characters',
    passwordRequirementDigit: 'Numbers',
    passwordRequirementLetter: 'Letter',
    passwordRequirementLowercase: 'Lower case letters',
    passwordRequirementSpecialCharacter: 'Special characters',
    passwordRequirementUppercase: 'Upper case letters',
    resendInMinute: 'Resend code in 1 minute',
    socialNetworkApple: 'Continue with Apple',
    socialNetworkFacebook: 'Continue with Facebook',
    socialNetworkGoogle: 'Continue with Google',
    socialNetworkVKontakte: 'Continue with VKontakte',
    socialNetworkWeChat: 'Continue with WeChat',
    userNotFound: 'User not found',
    usernameRequired: 'Username is required.'
};
export var translationsNamespace = 'ori-security-identity-ui';
